import { FlexContainer, TabPanel } from '@facephi/ui-react';
import { useTranslation } from 'react-i18next';
import {
  CredentialsTab,
  CustomerTab,
  PrivacyTab,
  SecurityTab,
  StyledTabs,
} from '../components/userDetail';

const UserDetailPage = () => {
  const { t } = useTranslation();

  return (
    <FlexContainer flex="1">
      <StyledTabs>
        <TabPanel name={t('Customer') as string} id="1">
          <CustomerTab />
        </TabPanel>
        <TabPanel name={t('Security') as string} id="2">
          <SecurityTab />
        </TabPanel>
        <TabPanel name={t('Privacy') as string} id="3">
          <PrivacyTab />
        </TabPanel>
        <TabPanel name={t('Credentials (vc)') as string} id="4">
          <CredentialsTab />
        </TabPanel>
      </StyledTabs>
    </FlexContainer>
  );
};
export default UserDetailPage;
